// Frontend metadata + resolution for the FIXED 8 document-kind buckets.
// The bucket IDS are the source of truth in the backend
// (workers/api/src/lib/record-category.ts) — keep this list in sync. This file
// only owns the display (label/emoji) and the effective-category resolution.

import type { CaseRecord } from "../types";

export type CategoryId =
  | "repair_estimate"
  | "vehicle_valuation"
  | "rental_transport"
  | "insurance_correspondence"
  | "claim_documentation"
  | "police_report"
  | "photo_evidence"
  | "other";

export interface CategoryMeta {
  id: CategoryId;
  label: string;
  emoji: string;
}

// Display order for the filter bar (specific → general, 'other' last).
export const RECORD_CATEGORIES: CategoryMeta[] = [
  { id: "repair_estimate", label: "Repair estimate/invoice", emoji: "🔧" },
  { id: "vehicle_valuation", label: "Vehicle valuation", emoji: "🚙" },
  { id: "rental_transport", label: "Rental/transportation", emoji: "🚗" },
  { id: "insurance_correspondence", label: "Insurance correspondence", emoji: "📨" },
  { id: "claim_documentation", label: "Claim documentation", emoji: "📑" },
  { id: "police_report", label: "Police/incident report", emoji: "🚓" },
  { id: "photo_evidence", label: "Photo evidence", emoji: "📷" },
  { id: "other", label: "Other", emoji: "🗂️" },
];

const BY_ID = new Map<string, CategoryMeta>(
  RECORD_CATEGORIES.map((c) => [c.id, c]),
);

export function categoryMeta(id: string | null | undefined): CategoryMeta {
  return (id && BY_ID.get(id)) || BY_ID.get("other")!;
}

// The category a record actually shows as: a user override wins over the
// deterministic auto value; both absent → 'other' (every record lands somewhere).
export function effectiveCategory(r: CaseRecord): CategoryId {
  const raw = r.category_override || r.record_category || "other";
  return (BY_ID.has(raw) ? raw : "other") as CategoryId;
}
